import { RouteConfig } from 'vue-router';

const baseUrl = '20260901JQDM';
const pageTitle = '川渝重点旅游景区住宿场所卫生“你点名  我监督”';

const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/home`,
  meta: { title: pageTitle },
  children: [
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Home.vue'),
      meta: { title: pageTitle },
    },
    {
      path: 'pick',
      name: `${baseUrl}-pick`,
      component: () => import('./pages/Pick.vue'),
      meta: { title: pageTitle },
    },
    {
      path: 'success',
      name: `${baseUrl}-success`,
      component: () => import('./pages/Success.vue'),
      meta: { title: pageTitle },
    },
    {
      path: 'rank',
      name: `${baseUrl}-rank`,
      component: () => import('./pages/Rank.vue'),
      meta: { title: pageTitle },
    },
  ],
};

export default route;
